import { render, staticRenderFns } from "./AjaxCheckbox.vue?vue&type=template&id=149060e4&"
import script from "./AjaxCheckbox.vue?vue&type=script&lang=js&"
export * from "./AjaxCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports